// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXfndMYGUMlkjuOYOEYaBZ78HoY-GIpbo",
  authDomain: "anonymous-complaint-portal.firebaseapp.com",
  databaseURL: "https://anonymous-complaint-portal-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "anonymous-complaint-portal",
  storageBucket: "anonymous-complaint-portal.appspot.com",
  messagingSenderId: "1052753088784",
  appId: "1:1052753088784:web:c8da6e5b3f751250105595",
  measurementId: "G-8MHM09ZVQE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
export const functions = getFunctions(app);
export const db = getFirestore(app); 
export default app;